import { useState } from "react";
import CheckboxInput from "components/CheckboxInput/CheckboxInput";
import { Eyes, Feet } from "enums/Test";
import { IBalanceTestItem } from "interfaces/Order";
import { formatFeetLabel } from "helpers/TestHelper";
import ConfirmationDialog from "components/Modals/ConfirmationDialog/ConfirmationDialog";

interface BalanceParameterInputProps {
  feet: Feet;
  tests: IBalanceTestItem[];
  onChange: (value: IBalanceTestItem[]) => void;
}

const BalanceParameterInput = (props: BalanceParameterInputProps) => {
  const { feet, tests, onChange } = props;

  const [isEyesClosedConfirmationOpen, setIsEyesClosedConfirmationOpen] =
    useState<boolean>(false);

  const isEyesOpenChecked = tests.some(
    ({ params }) => params.feet === feet && params.eyes === Eyes.Open
  );

  const isEyesClosedChecked = tests.some(
    ({ params }) => params.feet === feet && params.eyes === Eyes.Closed
  );

  const handleEyesOpenChange = (checked: boolean): void => {
    if (checked) {
      // Add Eyes Open for this feet position
      const newValue = [
        ...tests.filter(
          ({ params }) => !(params.feet === feet && params.eyes === Eyes.Open)
        ),
        { params: { feet, eyes: Eyes.Open } },
      ];
      onChange(newValue);
    } else {
      // Remove Eyes Open for this feet position
      const newValue = tests.filter(
        ({ params }) => !(params.feet === feet && params.eyes === Eyes.Open)
      );
      onChange(newValue);
    }
  };

  const handleEyesClosedChange = (checked: boolean): void => {
    if (checked) {
      // Show confirmation dialog
      setIsEyesClosedConfirmationOpen(true);
    } else {
      // Remove Eyes Closed for this feet position
      const newValue = tests.filter(
        ({ params }) => !(params.feet === feet && params.eyes === Eyes.Closed)
      );
      onChange(newValue);
    }
  };

  const handleConfirmEyesClosedDialog = (): void => {
    // Add Eyes Closed for this feet position
    const newValue = [
      ...tests.filter(
        ({ params }) => !(params.feet === feet && params.eyes === Eyes.Closed)
      ),
      { params: { feet, eyes: Eyes.Closed } },
    ];
    onChange(newValue);
    setIsEyesClosedConfirmationOpen(false);
  };

  return (
    <>
      <div className="flex flex-wrap gap-5 items-center py-2.5 border-b border-pelorous/30 last:border-b-0 last:pb-0">
        <div className="w-full md:w-[calc(58%-12.5px)] text-base font-medium text-cloudBurst">
          {formatFeetLabel(feet)}
        </div>
        <div className="w-full md:w-[calc(42%-12.5px)] flex gap-4">
          <div className="flex-1 flex justify-center">
            <CheckboxInput
              label=""
              value={isEyesOpenChecked}
              onChange={handleEyesOpenChange}
            />
          </div>
          <div className="flex-1 flex justify-center">
            <CheckboxInput
              label=""
              value={isEyesClosedChecked}
              onChange={handleEyesClosedChange}
            />
          </div>
        </div>
      </div>

      {isEyesClosedConfirmationOpen && (
        <ConfirmationDialog
          title="Eyes Closed Testing"
          content="Patient may be unsupervised, are you sure you want to order Eyes
          Closed Balance testing?"
          onConfirm={handleConfirmEyesClosedDialog}
          onClose={() => setIsEyesClosedConfirmationOpen(false)}
        />
      )}
    </>
  );
};

export default BalanceParameterInput;
